import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Navbar from "./Common/Navbar";
import Footer from "./Common/Footer";
import Homepage from "./Pages/Homepage";
import AboutUs from "./Pages/AboutUs";
import ProgramsPage from "./Pages/Program";
import GalleryPage from "./Pages/Gallery";
import Blog from "./Pages/Blog";
import ContactUs from "./Pages/ContactUs";
import EventRegistrationPage from "./Pages/EventRegistrationPage";
import Login from "./Common/Login";
import Signup from "./Common/Signup";
import PopupManager from "./Common/PopupManager";
import WhatsAppWidget from "./Common/WhatsAppWidget"; // Import WhatsApp widget
import AdminRoute from "./Common/AdminRoute";
import AdminDashboard from "./Pages/AdminDashboard";
import { AuthProvider } from "./context/AuthContext";
import TestimonialsSection from "./Pages/Testimonials";
import LocationSEOPage from "./Pages/SeoPages/LocationSEOPage";

function ScrollManager() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  return null;
}

function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  const shouldOffsetForNavbar = !isAdminRoute && location.pathname !== "/";

  return (
    <AuthProvider>
      <div className="min-h-screen">
        <ScrollManager />
        {!isAdminRoute && <Navbar />}
        {!isAdminRoute && <PopupManager />}
        {!isAdminRoute && <WhatsAppWidget />} {/* Add WhatsApp widget */}
        <main className={shouldOffsetForNavbar ? "pt-28" : ""}>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/programs" element={<ProgramsPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/event-registration" element={<EventRegistrationPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/testimonials" element={<TestimonialsSection />} />
            <Route path="/locations/:pageType/:locSlug" element={<LocationSEOPage />} />
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AdminDashboard />
                </AdminRoute>
              }
            />
            <Route path="*" element={<LocationSEOPage />} />
          </Routes>
        </main>
        {!isAdminRoute && <Footer />}
      </div>
    </AuthProvider>
  );
}

export default App;
